export enum DepartmentType {
  Activation = 1,
  Backoffice = 2,
  CustomerSupport = 3,
  IT = 4,
  Marketing = 5,
  Partnership = 6,
  ProductManagement = 7,
  Sales = 8,
  SoftwareQualityAssurance = 9,
  TPA = 10,
  Payments = 11,
  Compliance = 12,
  Translators = 13,
  CountryManager = 14,
}

export const isDepartmentPartnership = (departmentType: number): boolean => {
  return DepartmentType.Partnership === departmentType
}

export const isDepartmentPayments = (departmentType: number): boolean => {
  return DepartmentType.Payments === departmentType
}

export const isDepartmentsPayments = (departmentTypes: number[] = []): boolean => {
  return departmentTypes.includes(DepartmentType.Payments)
}
